import { render, staticRenderFns } from "./ArticleExamDetail.vue?vue&type=template&id=7bf918de&scoped=true&"
import script from "./ArticleExamDetail.vue?vue&type=script&lang=js&"
export * from "./ArticleExamDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArticleExamDetail.vue?vue&type=style&index=0&id=7bf918de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf918de",
  null
  
)

component.options.__file = "ArticleExamDetail.vue"
export default component.exports